import { AxiosError } from "axios";

import { logger } from "#app/monitoring/Logger";

export const errorHandler = (err: unknown) => {
  if (err instanceof AxiosError) {
    logger.error(err.message, err);
  }
};
